<template>
  <div class="test-item">
    <div class="test-item-tigan">
      <div class="test-item-tigan-html" v-html="data.questionBody"></div>
      <div v-if="showSound==true&&data.questionSound"><span class="icon iconfont iconyinpin hand"
                                                            @click=playSound(data.questionSound)></span></div>
      <slot name="toolbar"></slot>
    </div>
    <audio :src="data.questionSound" :id="'test'+data.questionId"></audio>
    <div class="test-item-questionOpt" v-for="item in data.questionOpt"><label
        v-if="data.questionAnswer==item.option"><input type="radio" :name="'radio-item'+data.questionId"
                                                       disabled="disabled" checked/><span>{{item.option}}</span></label><label
        v-else><input type="radio" :name="'radio-item'+data.questionId"
                      disabled="disabled"/><span>{{item.option}}</span></label></div>
    <div class="test-item-daan" v-if="showAnswer==true">
      <el-tag size="small" type="success " style="margin-right:1em">答案</el-tag>
      {{data.questionAnswer}}
    </div>
    <div class="test-item-jiexi" v-if="showResolve==true">
      <el-tag size="small" type="success " style="margin-right:1em">解析</el-tag>
      <p v-html="data.questionResolve"></p></div>
    <div class="test-item-createtime" v-if="showTimer==true">创建于：{{data.createTimeStr}}</div>
  </div>
</template>

<script>
  export default {
    name: 'TestItemJudge',
    props: {
      data: {
        required: true
      },
      showAnswer: {
        type: Boolean,
        default: true
      },
      showResolve: {
        type: Boolean,
        default: true
      },
      showTimer: {
        type: Boolean,
        default: true
      },
      showSound: {
        type: Boolean,
        default: true
      },
      testIndex: {
        type: Number,
        default: 1
      },
      testPoint: {
        type: Number,
        default: 0
      }
    },
    methods: {
      playSound(val) {
        var audio = document.getElementsByTagName('audio');
        for (var i = 0; i < audio.length; i++) {
          audio[i].pause();
        }
        let player = document.querySelector('#test' + this.data.questionId);
        if (player.paused) {
          player.play();
        } else {
          player.pause();
        }
      }
    },
    created() {
      var questionOpt = JSON.parse(decodeURIComponent(this.data.questionOpt));
      this.data.questionOpt = questionOpt;
      this.data.questionAnswer = decodeURIComponent(this.data.questionAnswer);
      this.data.questionResolve = decodeURIComponent(this.data.questionResolve);
      if (this.data.questionSound == '') {
        this.data.questionSound = null;
      }
      if (this.data.questionBody) {
        var questionBody = decodeURIComponent(this.data.questionBody);
        var index = this.testIndex <= 0 ? '' : this.testIndex + '. ';
        var point = this.testPoint <= 0 ? '' : '（' + this.testPoint + '分）';
        this.data.questionBody = index + point + questionBody;
      }
      //this.data.questionResolve = this.data.questionResolve?this.data.questionResolve:"无";
      //<div class="test-index" v-text="testIndex" v-if="testIndex"></div><div v-if="testPoint" class="test-point" v-text="testPoint"></div>
    }
  };
</script>

<style scoped>

</style>
